import { funcType } from '@lc/types/Misc';

import { Event, EventVerbose } from './types';

export function createCardEvent(
	id: number = -1,
	cost: number = 0,

	title: string = ``,
	description: string = ``,
	flavor: string = ``,

	requireTarget: boolean = false,
	requireSource: boolean = false,
	requireDecision: boolean = false
): Event {
	const type = 'Event';

	return {
		id,
		cost,
		type,

		title,
		description,
		flavor,

		requireTarget,
		requireSource,
		requireDecision,
	};
}

export function createCardEventVerbose(
	event: Event,
	action: funcType
): EventVerbose {
	return {
		...event,
		action,
	};
}
